import React, { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const GUARDIAN_ORANGE = '#E06A10';

export interface RequestSentStepProps {
  onContinue: () => void;
}

const RequestSentStep: FC<RequestSentStepProps> = ({ onContinue }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: 380,
        mx: 'auto',
        py: 2,
      }}
    >
      {/* Send icon badge */}
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          backgroundColor: `${GUARDIAN_ORANGE}18`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <SendIcon sx={{ color: GUARDIAN_ORANGE, fontSize: 28 }} />
      </Box>

      <Typography variant="h5" fontWeight={700} mb={1}>
        Request Sent!
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3} sx={{ lineHeight: 1.7 }}>
        We&apos;ve notified your athlete. Once they approve your request, you&apos;ll be linked as their guardian.
      </Typography>

      {/* What happens next info box */}
      <Box
        sx={{
          width: '100%',
          textAlign: 'left',
          p: 2,
          borderRadius: 2,
          backgroundColor: `${GUARDIAN_ORANGE}10`,
          border: `1px solid ${GUARDIAN_ORANGE}30`,
          mb: 4,
        }}
      >
        <Typography variant="body2" fontWeight={700} sx={{ color: GUARDIAN_ORANGE, mb: 0.5 }}>
          What happens next?
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.6 }}>
          Your athlete will receive an email to approve your guardian access. You&apos;ll be notified once they accept.
        </Typography>
      </Box>

      <Button
        variant="contained"
        fullWidth
        onClick={onContinue}
        sx={{
          borderRadius: 999,
          py: 1.25,
          fontWeight: 600,
          fontSize: 15,
          backgroundColor: GUARDIAN_ORANGE,
          boxShadow: 'none',
          '&:hover': { backgroundColor: GUARDIAN_ORANGE, filter: 'brightness(0.9)', boxShadow: 'none' },
        }}
      >
        Continue
      </Button>
    </Box>
  );
};

export default RequestSentStep;
